import { combineReducers } from 'redux';
import produce from 'immer';
import { ActivityRunAction, ActivityRunActionType } from '../../actions/activityRunActions';
import { ActivityRunConsoleMessage } from '../../types/resources';

type BySeqNoState = {
  [seqNo: number]: ActivityRunConsoleMessage;
};

interface ByActivityRunIdState {
  byActivityRunId: Record<string, { bySeqNo: BySeqNoState }>;
}

export const initialState: ByActivityRunIdState = {
  byActivityRunId: {},
};

const byActivityRunId = (state = initialState.byActivityRunId, action: ActivityRunAction) =>
  produce(state, (draft) => {
    switch (action.type) {
      case ActivityRunActionType.GET_ACTIVITY_RUN_CONSOLE: {
        draft[action.activityRunId] = { bySeqNo: {} };
        break;
      }
      case ActivityRunActionType.GET_ACTIVITY_RUN_CONSOLE_OK: {
        action.data.forEach((consoleEvent) => {
          draft[action.activityRunId].bySeqNo[consoleEvent.seqNo] = consoleEvent;
        });

        break;
      }
      case ActivityRunActionType.SET_ACTIVITY_RUN_CONSOLE_MESSAGE_EVENT: {
        draft[action.event.runId] = draft[action.event.runId]
          ? { ...draft[action.event.runId] }
          : { bySeqNo: {} };
        draft[action.event.runId].bySeqNo[action.event.seqNo] = action.event;
        break;
      }
      default:
        return state;
    }
  });

export default combineReducers({
  byActivityRunId,
});
